var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../../converters/DateConverter";
export class ArchiveFileInfo {
  constructor(_data) {
    /**
     */
    __publicField(this, "FileName");
    /**
     */
    __publicField(this, "GeneratedAt");
    /**
     */
    __publicField(this, "Id");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof ArchiveFileInfo
     */
    __publicField(this, "$type", "V1.Cesop.Periods.ArchiveFileInfo");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.FileName = _data["FileName"];
      this.GeneratedAt = DateConverter.from(_data["GeneratedAt"]);
      this.Id = _data["Id"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["FileName"] = this.FileName;
    _data["GeneratedAt"] = DateConverter.toIsoUtcString(this.GeneratedAt);
    _data["Id"] = this.Id;
    return _data;
  }
}
